/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function ViewBoardIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="view-board"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M5.363 3.505C6.242 3.475 7.121 3.498 8 3.5C8.66 3.501 9.289 3.834 9.658 4.382C9.755 4.525 9.833 4.68 9.89 4.843C9.963 5.054 10 5.277 10 5.5C10.002 9.833 10 14.167 10 18.5C9.992 18.726 9.964 18.943 9.89 19.157C9.706 19.687 9.295 20.124 8.778 20.343C8.572 20.43 8.359 20.473 8.137 20.495C7.258 20.525 6.379 20.502 5.5 20.5C4.84 20.499 4.211 20.166 3.842 19.618C3.745 19.475 3.667 19.32 3.61 19.157C3.537 18.946 3.5 18.723 3.5 18.5C3.498 14.167 3.5 9.833 3.5 5.5C3.508 5.274 3.536 5.057 3.61 4.843C3.794 4.313 4.205 3.876 4.722 3.657C4.928 3.57 5.141 3.527 5.363 3.505Z" data-tinysvg-shape="path" stroke="none" fill={color} data-fill-tone="primary" />
          <path d="M5.5 3.5C4.395 3.5 3.5 4.395 3.5 5.5L3.5 18.5C3.5 19.605 4.395 20.5 5.5 20.5L8 20.5C9.105 20.5 10 19.605 10 18.5L10 5.5C10 4.395 9.105 3.5 8 3.5L5.5 3.5Z" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M15.863 3.505C16.742 3.475 17.621 3.498 18.5 3.5C19.16 3.501 19.789 3.834 20.158 4.382C20.255 4.525 20.333 4.68 20.39 4.843C20.463 5.054 20.5 5.277 20.5 5.5C20.501 7.167 20.5 8.833 20.5 10.5C20.492 10.726 20.464 10.943 20.39 11.157C20.191 11.729 19.729 12.191 19.157 12.39C18.943 12.464 18.726 12.492 18.5 12.5C17.667 12.5 16.833 12.501 16 12.5C15.34 12.499 14.711 12.166 14.342 11.618C14.245 11.475 14.167 11.32 14.11 11.157C14.037 10.946 14 10.723 14 10.5C13.999 8.833 14 7.167 14 5.5C14.008 5.274 14.036 5.057 14.11 4.843C14.294 4.313 14.705 3.876 15.222 3.657C15.428 3.57 15.641 3.527 15.863 3.505Z" data-tinysvg-shape="path" stroke="none" fill={color} data-fill-tone="primary" />
          <path d="M16 3.5C14.895 3.5 14 4.395 14 5.5L14 10.5C14 11.605 14.895 12.5 16 12.5L18.5 12.5C19.605 12.5 20.5 11.605 20.5 10.5L20.5 5.5C20.5 4.395 19.605 3.5 18.5 3.5L16 3.5Z" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
    </svg>
  )
}
